/** HTML 输入变化后的统一确认；下载提示不依赖短暂 Toast，待更新状态由服务器持久维护。 */
import type { ProjectChange } from '~/data/queries';
import { ConfirmDialog, Dialog } from '~/ui/Dialog';
export function LandingProjectRegenerationPrompt({
  change,
  onGenerate,
  onClose,
  blockedReason,
}: { change: ProjectChange; onGenerate: () => void; onClose: () => void; blockedReason?: string }) {
  if (blockedReason)
    return (
      <Dialog
        title="修改已保存，暂时不能生成"
        onClose={onClose}
        footer={
          <button type="button" className="btn" onClick={onClose}>
            关闭
          </button>
        }
      >
        <div style={{ padding: 18 }}>
          <p role="alert">{blockedReason}</p>
          <p>旧 HTML 默认不能下载为当前版本。书籍恢复可投放后，请重新生成并重新下载。</p>
        </div>
      </Dialog>
    );
  return (
    <ConfirmDialog
      title="修改已保存，需要重新生成并重新下载"
      message={`本次修改影响 ${change.affected_task_count} 个任务。请重新生成 HTML 并重新下载使用；之前下载的文件不会自动更新。`}
      details={[change.reason, '稍后处理时，旧 HTML 默认不能下载或作为当前版本发布。']}
      confirmLabel="现在重新生成"
      cancelLabel="稍后处理"
      icon="IconRefresh"
      onConfirm={onGenerate}
      onClose={onClose}
    />
  );
}
